import React, { useEffect,useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import withAuthorization from 'components/Session/withAuthorization';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import API from '../../../services/api';
//import axios from 'axios';
import { useFirebase } from 'components/Firebase/context';

const useStyles = makeStyles(theme => ({
  table: {
    minWidth: 650,
  },
}));
function createData(name, email, membership_type, role, craeted_at) {
    return { name, email, membership_type, role, craeted_at };
  }
  
  const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  ];
const Users = () => {
  const classes = useStyles();
  const firebase = useFirebase();
  const [getUsers, setgetUsers] = useState({users:[]})
  
  useEffect(() => { 
    const getAllUsers = async () => {
        // const user = firebase.getProfile();
        // const refToken = firebase.checkTest(user.uid);
        // refToken.get().then((snap) => {
        //   snap.forEach((doc) => {
        //       console.log(doc);
        //   });
        // });
    await API.get('getAllUsers')
        .then((res) => {
            if(res.data.status == 'success'){
                // res.data.users.map(user  => {
                //     const collection = async () => {
                //     const test = await firebase.getUserDataById(user.uid).then((resp) => 
                //     { 
                //         console.log("===>ddd",resp); 
                //     });
                //     }
                // })
                setgetUsers({
                    users: res.data.users
                })
            }
        })
    };
    // const user = firebase.getProfile();
    // console.log(user);
    // const getUserDataByIda = async () => {
    //     const test = await firebase.getUserDataById('0FsVdAn3z6MuTlII4Qk2fnIcc2z1').then((resp) => { return resp });
    //     console.log(test,"test123456789");    
    // };
    getAllUsers();
   // getUserDataByIda();
  }, []);
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Membership Type</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {getUsers.users && getUsers.users.map(user => (
            <TableRow  key={user.uid}>
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.membership_type}</TableCell>
              <TableCell>{user.role}</TableCell>
              <TableCell>{user['metadata'].creationTime}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default withAuthorization()(Users);
